import React, {useState, useEffect, useContext, useCallback} from 'react';
import { BsCloudDownload } from "react-icons/bs";

export const HFDocumentsCooperative = () => {


	const files = [
			{
				name:"Muster-/Kleinstgenossenschaft Satzung",
				path:`${process.env.PUBLIC_URL}/formes/2401 Entwurf ZdK TC-Erste-Kleinstgenossenschaft_Satzung.docx`,
				tag: ["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"Projektbeschreibung TC Erste Kleinstgenossenschaft",
				path:`${process.env.PUBLIC_URL}/formes/Projektbeschreibung TC Erste Kleinstgenossenschaft.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"Checkliste zur Gründungsprüfung",
				path:`${process.env.PUBLIC_URL}/formes/2101 Checkliste Gründung für FP 3 Jahre.docx`,
				tag:["Gründung", "Checkliste"],
				type:"docx"
			},
			{
				name:"Genossenschaftsgründung - Finanzplan",
				path:`${process.env.PUBLIC_URL}/formes/formes/2101 Finanzplan ZdK 10 Jahre.xlsx`,
				tag:["Gründung","Vorlage"],
				type:"xlsx"
			},
			{
				name:"Gründungsunterlagen - Fahrplan",
				path:`${process.env.PUBLIC_URL}/formes/Gruendungsunterlagen.pdf`,
				tag:["Gründung","Information"],
				type:"pdf"
			},
			{
				name:"KLEINE eG - Anwesenheitsliste und Beteiligungserklärungen der Gründungsversammlung und ersten Generalversammlung der eG i. G.",
				path:`${process.env.PUBLIC_URL}/formes/Anwesenheitsliste KLEINE eG.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"KLEINE eG - Protokoll der Gründungsversammlung und ersten Generalversammlung der eG i. G.",
				path:`${process.env.PUBLIC_URL}/formes/Anwesenheitsliste KLEINE eG.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"WOHN eG - Anwesenheitsliste und Beteiligungserklärungen der Gründungsversammlung und ersten Generalversammlung der eG i. G.",
				path:`${process.env.PUBLIC_URL}/formes/Anwesenheitsliste WOHN eG.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"Musterniederschrift einer Generalversammlung",
				path:`${process.env.PUBLIC_URL}/formes/Protokoll_Generalversammlung_mit_AR_01.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"Beitrittserklärung / Zeichnung von Genossenschaftsanteilen",
				path:`${process.env.PUBLIC_URL}/formes/Beitrittserklärung+Datenschutz.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"Projektkalkulation Bewohnergetragene Baugemeinschaft & Genossenschaft Neugründung",
				path:`${process.env.PUBLIC_URL}/formes/Kalkulator_Oeffentliche-Mittel-V14_Baugebiet-Name.xlsx`,
				tag:["Gründung","Vorlage"],
				type:"xlsx"
			},
			{
				name:"Verbindlichkeitenspiegel",
				path:`${process.env.PUBLIC_URL}/formes/478_verbindlichkeitenspiegel_beschreibbar.pdf`,
				tag:["Gründung","Vorlage"],
				type:"pdf"
			},
			{
				name:"Genossenschaften Anzeigentext",
				path:`${process.env.PUBLIC_URL}/formes/Genossenschaften_Anzeigentext_final-2.docx`,
				tag:["Gründung","Vorlage"],
				type:"docx"
			},
			{
				name:"HomeFamily-TC-Kommunal-Information",
				path:`${process.env.PUBLIC_URL}/formes/HomeFamily-TC-Kommunal-Information 2024-03-26.pptx`,
				tag:["Präsentation"],
				type:"pptx"
			},
			{
				name:"Selbstauskunft",
				path:`${process.env.PUBLIC_URL}/formes/KDA0-00474_Selbstauskunft_v05_230209.pdf`,
				tag:["Formular"],
				type:"pdf"
			},
			{
				name:"Prospekt Genossenschaft Home&Family Service",
				path:`${process.env.PUBLIC_URL}/formes/Prospekt Genossenschaft Home&Family Service.pdf`,
				tag:["Prospekt"],
				type:"pdf"
			},
			{
				name:"Vertriebsanleitung zur Begleitung der Projektmoderation im genossenschaftlichen Wohnen",
				path:`${process.env.PUBLIC_URL}/formes/Vertriebsinfo_Projektmoderation-Genossenschaft.docx`,
				tag:["Anleitung"],
				type:"pdf"
			},
			{
				name:"Mitgliederliste",
				path:`${process.env.PUBLIC_URL}/formes/Mitgliederliste.xlsx`,
				tag:["Vorlage","Gründung"],
				type:"pdf"
			},
			{
				name:"Kostengruppen DIN-276",
				path:`${process.env.PUBLIC_URL}/formes/Kostengruppen_DIN_276.xlsx`,
				tag:["Vorlage","Gründung"],
				type:"pdf"
			}
		]







	return (
		<div className={"mx-auto max-w-7xl orderDetails"}>
			<main>
				<div className="w-full flex">
					<div className={"text-base items-center px-6 mt-8 mb-10 leading-7 text-gray-600"}>
						<div className="mt-2 sm:flex items-center sm:justify-between">
							<div className="min-w-0 mb-4 flex flex-1">
								<h2 className="w-full text-xl truncate mb-4 Lg:ml-4 sm:mb-0 lg:text-2xl textShadow flex font-normal leading-7 text-gray-600 sm:truncate  sm:tracking-tight gap-2">
									Genossenschaftsgründung
								</h2>
							</div>
						</div>
						<nav aria-label="Breadcrumb" className={"mb-10"} >
							<ol role="list" className="flex items-center space-x-4">
								<li key={"Dokumenten Hub"}>
									<div className="flex items-center">
										<a href={"/documents"} className="mr-4 text-sm font-medium text-gray-900">
											Dokumenten Hub
										</a>
										<svg viewBox="0 0 6 20" aria-hidden="true" className="h-5 w-auto text-gray-300">
											<path d="M4.878 4.34H3.551L.27 16.532h1.327l3.281-12.19z" fill="currentColor" />
										</svg>
									</div>
								</li>

							</ol>
						</nav>

						<div>
							<ul className={" "}>

								{files?.map((e) => (
									<li  className={"xl:flex border-b py-2 gap-4 hover:bg-gray-200 justify-between border-gray-400"}>
										<div className={"w-full  xl:w-8/12 truncate"}>
											<a href={e?.path}>{e?.name}</a>
										</div>
										<div  className={"w-full xl:justify-between flex xl:w-4/12 truncate"}>
											<div className={"w-2/6 truncate"}>
												<span className={"text-xs border-gray-400 border mr-2 rounded px-2 py-1"}>{e?.type}</span>
											</div>
											<div className={"w-3/6 truncate"}>
												{e?.tag?.map((a) => (
													<span className={"text-xs bg-indigo-900/20 border-gray-400 border mr-2 rounded px-2 py-1"}>{a}</span>
												))}
											</div>
											<div className={"w-1/6 p-2 text-xs truncate"}>
												<a href={e?.path}><BsCloudDownload /></a>
											</div>
										</div>
									</li>
								))}

							</ul>
						</div>
					</div>
				</div>
			</main>
		</div>
	)

}
